// Lib
import React, { ReactElement } from 'react';
import { useDispatch } from 'react-redux';

// Util
import { getListChildNewLocation } from '../../../../../common/elements/utils/elementLocationUtils';
import { canWrite } from '../../../../../common/permissions/permissionUtil';
import { isPlatformAndroid } from '../../../../platform/utils/platformDetailsUtils';
import platformSingleton from '../../../../platform/platformSingleton';
import { createNewImageFromCameraOrAlbumPicker } from '../../../utils/capacitorCreateNewImageFromCameraOrAlbum';

// Components
import Icon from '../../../../components/icons/Icon';
import ToolbarTool from '../../../../workspace/toolbar/components/ToolbarTool';
import FileUploadForm from '../../../../components/tools/files/FileUploadForm';

// Constants
import { ELEMENT_CREATION_SOURCES } from '../../../../../common/elements/elementConstants';

// Types
import { ToolbarItemsListRequiredProps } from '../../../../workspace/toolbar/components/ToolbarItemsList';

type MobileImageToolProps = ToolbarItemsListRequiredProps;

const getElementLocation = ({ currentBoardId }: MobileImageToolProps) =>
    getListChildNewLocation({ listId: currentBoardId });

const MobileImageTool = (props: MobileImageToolProps): ReactElement | null => {
    if (!canWrite(props.permissions)) return null;
    const dispatch = useDispatch();

    return (
        <FileUploadForm
            {...props}
            getElementLocation={getElementLocation}
            creationSource={ELEMENT_CREATION_SOURCES.MOBILE_UPLOAD}
        >
            {(openFileInput: () => void) => {
                const handleClick = () => {
                    if (isPlatformAndroid(platformSingleton)) {
                        createNewImageFromCameraOrAlbumPicker(dispatch, getElementLocation(props));
                    } else {
                        openFileInput();
                    }
                };

                return (
                    <ToolbarTool className="MobileImageTool" name="Image" onClick={handleClick}>
                        <Icon name="toolbar-camera" />
                    </ToolbarTool>
                );
            }}
        </FileUploadForm>
    );
};

export default MobileImageTool;
